import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

/**
 * Visual indicator for in-flight operations.
 *
 * GAP-FE-021B · migrated from decorator-based @Input to signal-based input().
 */
@Component({
  selector: 'app-spinner',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.css'
})
export class SpinnerComponent {
  readonly size = input<'sm' | 'md' | 'lg' | 'xl'>('md');
  readonly variant = input<'circular' | 'dots' | 'pulse'>('circular');
  readonly color = input<'primary' | 'white' | 'current'>('primary');

  readonly sizeClass = computed<string>(() => `size-${this.size()}`);
}
